<app-modal-header-common [title]="modalHeader" [dialogRef]="dialogRef">
</app-modal-header-common>

<!-- ==================== TEMPLATE DETAILS ==================== -->
<div class="plan-form" [hidden]="step === 2">
  <form [formGroup]="templateForm">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" required />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Frequency</mat-label>
      <mat-select formControlName="frequency" required>
        <mat-option *ngFor="let option of frequencies" [value]="option.id">
          {{ option.display_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Type</mat-label>
      <mat-select formControlName="type" required>
        <mat-option *ngFor="let option of auditTypes" [value]="option.id">
          {{ option.display_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Applicability</mat-label>
      <input matInput formControlName="applicability" />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Focus Area</mat-label>
      <input matInput formControlName="focus_area" />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Internal assessor</mat-label>
      <mat-select formControlName="internal_assessor">
        <mat-option *ngFor="let option of usersList" [value]="option.id">
          {{ option.first_name + " " + option.last_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-slide-toggle class="mb-3" formControlName="is_external_assessment"
      >Is external assessment</mat-slide-toggle
    >
    <mat-form-field
      class="w-100"
      appearance="outline"
      *ngIf="templateForm.get('is_external_assessment')?.value"
    >
      <mat-label>External assessor</mat-label>
      <input matInput formControlName="external_assessor" />
    </mat-form-field>
    <app-tag
      [noIds]="true"
      [tagsIds]="assessmentTags"
      (childTags)="getChildTags($event)"
    ></app-tag>

    <!-- Old behavior: single Create button, closes immediately -->
    <div
      *ngIf="!isCreateMode"
      style="display: flex; justify-content: end"
      class="mt-3"
    >
      <button mat-button mat-dialog-close color="primary" class="mx-1">
        Close
      </button>
      <button
        mat-raised-button
        color="primary"
        class="templ-btn"
        (click)="createAssessment()"
        [disabled]="templateForm.invalid"
      >
        Create
      </button>
    </div>

    <div
      *ngIf="isCreateMode"
      style="display: flex; justify-content: end"
      class="mt-3"
    >
      <button mat-button mat-dialog-close color="primary" class="mx-1">
        Close
      </button>
      <button
        mat-raised-button
        color="primary"
        class="templ-btn"
        (click)="goNext()"
      >
        Next
      </button>
    </div>
  </form>
</div>

<!-- ==================== DOMAIN/SUBDOMAIN/REQUIREMENT TREE ==================== -->
<div class="p-3" [hidden]="step === 1">
  <div class="d-flex" style="gap: 12px; height: 65vh">
    <!-- ==================== LEFT: TREE ==================== -->
    <div
      class="tree-pane"
      style="
        width: 30%;
        min-width: 260px;
        display: flex;
        flex-direction: column;
        border: 1px solid #d9d9d9;
        border-radius: 8px;
        background: #f7f7f7;
        overflow: hidden;
      "
    >
      <div style="flex: 1; overflow-y: auto; padding: 6px">
        <div
          *ngFor="let domainGroup of domainGroups; let di = index"
          class="mb-1"
          style="
            border: 1px solid #dcdcdc;
            border-radius: 6px;
            background: white;
            overflow: hidden;
          "
        >
          <!-- Domain row -->
          <div
            class="d-flex align-items-center"
            style="gap: 4px; padding: 4px 6px; background: #eef0f2"
          >
            <mat-icon
              style="
                cursor: pointer;
                font-size: 20px;
                width: 20px;
                height: 20px;
              "
              (click)="toggleDomain(domainGroup)"
            >
              {{ domainGroup.expanded ? "expand_more" : "chevron_right" }}
            </mat-icon>
            <span
              *ngIf="domainHasError(domainGroup)"
              class="error-dot"
              matTooltip="This domain has incomplete fields"
            ></span>
            <input
              class="tree-input tree-input-domain"
              [(ngModel)]="domainGroup.domain"
              name="domain{{ di }}"
              placeholder="Domain name"
            />
            <button
              mat-icon-button
              matTooltip="Add subdomain"
              style="width: 26px; height: 26px; line-height: 26px"
              (click)="addSubdomain(domainGroup, di)"
            >
              <mat-icon style="font-size: 16px; width: 16px; height: 16px"
                >add</mat-icon
              >
            </button>
            <button
              mat-icon-button
              color="warn"
              matTooltip="Remove domain"
              style="width: 26px; height: 26px; line-height: 26px"
              (click)="removeDomain(di)"
            >
              <mat-icon style="font-size: 16px; width: 16px; height: 16px"
                >delete</mat-icon
              >
            </button>
          </div>

          <div *ngIf="domainGroup.expanded" style="padding: 2px 0 2px 14px">
            <div
              *ngFor="
                let subdomainGroup of domainGroup.subdomains;
                let si = index
              "
              class="mt-1 mb-1"
              style="border-start: 2px solid #e0e0e0; padding-left: 6px"
            >
              <!-- Subdomain row -->
              <div
                class="d-flex align-items-center"
                style="gap: 4px; padding: 3px 4px"
              >
                <mat-icon
                  style="
                    cursor: pointer;
                    font-size: 18px;
                    width: 18px;
                    height: 18px;
                  "
                  (click)="toggleSubdomain(subdomainGroup)"
                >
                  {{
                    subdomainGroup.expanded ? "expand_more" : "chevron_right"
                  }}
                </mat-icon>
                <span
                  *ngIf="subdomainHasError(subdomainGroup)"
                  class="error-dot"
                  matTooltip="This subdomain has incomplete fields"
                ></span>
                <input
                  class="tree-input tree-input-subdomain"
                  [(ngModel)]="subdomainGroup.sub_domain"
                  name="subdomain{{ di }}_{{ si }}"
                  placeholder="Subdomain name"
                />
                <button
                  mat-icon-button
                  matTooltip="Add requirement"
                  style="width: 24px; height: 24px; line-height: 24px"
                  (click)="addRequirement(subdomainGroup, di, si)"
                >
                  <mat-icon style="font-size: 15px; width: 15px; height: 15px"
                    >add</mat-icon
                  >
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  matTooltip="Remove subdomain"
                  style="width: 24px; height: 24px; line-height: 24px"
                  [disabled]="domainGroup.subdomains.length === 1"
                  (click)="removeSubdomain(domainGroup, di, si)"
                >
                  <mat-icon style="font-size: 15px; width: 15px; height: 15px"
                    >delete</mat-icon
                  >
                </button>
              </div>

              <!-- Requirement rows -->
              <div *ngIf="subdomainGroup.expanded" style="padding-left: 16px">
                <div
                  *ngFor="
                    let req of subdomainGroup.requirements;
                    let ri = index
                  "
                  class="requirement-row d-flex align-items-center"
                  [class.requirement-row-selected]="isSelected(di, si, ri)"
                  (click)="selectRequirement(di, si, ri)"
                  style="
                    gap: 4px;
                    padding: 4px 6px;
                    cursor: pointer;
                    border-radius: 4px;
                  "
                >
                  <span
                    *ngIf="requirementHasError(req)"
                    class="error-dot"
                    matTooltip="Missing requirement text, a checklist item, or a valid response"
                  ></span>
                  <mat-icon
                    style="
                      font-size: 14px;
                      width: 14px;
                      height: 14px;
                      color: #999;
                    "
                  >
                    description
                  </mat-icon>
                  <span
                    class="requirement-label"
                    style="
                      flex: 1;
                      font-size: 12.5px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ requirementLabel(req) }}
                  </span>
                  <span
                    class="badge bg-light text-dark"
                    style="font-size: 10px"
                    matTooltip="Checklist items"
                  >
                    {{ req.checklist_items.length }} item{{
                      req.checklist_items.length === 1 ? "" : "s"
                    }}
                  </span>
                  <span
                    class="badge bg-light text-dark"
                    style="font-size: 10px"
                    matTooltip="Responses"
                  >
                    {{ req.response_choices.length }} resp
                  </span>
                  <button
                    mat-icon-button
                    color="warn"
                    matTooltip="Remove requirement"
                    style="width: 22px; height: 22px; line-height: 22px"
                    [disabled]="subdomainGroup.requirements.length === 1"
                    (click)="
                      removeRequirement(subdomainGroup, di, si, ri);
                      $event.stopPropagation()
                    "
                  >
                    <mat-icon style="font-size: 14px; width: 14px; height: 14px"
                      >delete</mat-icon
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="padding: 6px; border-top: 1px solid #dcdcdc">
        <button
          mat-stroked-button
          color="accent"
          style="width: 100%"
          (click)="addDomain()"
        >
          <mat-icon>add</mat-icon> Add Domain
        </button>
      </div>
    </div>

    <!-- ==================== RIGHT: DETAIL EDITOR ==================== -->
    <div
      class="detail-pane"
      style="
        flex: 1;
        overflow-y: auto;
        border: 1px solid #d9d9d9;
        border-radius: 8px;
        padding: 16px;
      "
    >
      <ng-container *ngIf="selectedRequirement; else noSelection">
        <div style="font-size: 12px; color: #888; margin-bottom: 8px">
          {{ selectedDomain?.domain || "Untitled domain" }}
          <mat-icon
            style="
              font-size: 13px;
              width: 13px;
              height: 13px;
              vertical-align: middle;
            "
            >chevron_right</mat-icon
          >
          {{ selectedSubdomain?.sub_domain || "Untitled subdomain" }}
        </div>

        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label> Requirement <span class="required">*</span> </mat-label>
          <textarea
            matInput
            [(ngModel)]="selectedRequirement.requirement"
            name="requirementDetail"
            rows="3"
          ></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 200px">
          <mat-label>Turn Around Time</mat-label>
          <input
            matInput
            type="number"
            min="1"
            [(ngModel)]="selectedRequirement.turn_around_time"
            name="turnAroundTimeDetail"
            placeholder="Business Days"
          />
          <span
            matSuffix
            style="font-size: 11px; color: #999; margin-right: 4px"
            >days</span
          >
        </mat-form-field>

        <div class="mt-3">
          <label style="font-size: 12px; color: #666"
            >Reference Documents</label
          >
          <button
            mat-stroked-button
            color="primary"
            class="ms-2"
            style="font-size: 12px; padding: 0 10px; line-height: 30px"
            (click)="refFileInput.click()"
          >
            <mat-icon style="font-size: 16px; vertical-align: middle"
              >attach_file</mat-icon
            >
            Add Reference Document
          </button>
          <div class="d-flex flex-wrap align-items-center gap-1 mt-1">
            <span
              *ngFor="
                let doc of selectedRequirement.reference_documents;
                let dri = index
              "
              class="badge bg-secondary d-flex align-items-center"
              style="padding: 6px 8px; font-size: 12px"
            >
              {{ doc.file_name }}
              <mat-icon
                style="
                  font-size: 14px;
                  width: 14px;
                  height: 14px;
                  cursor: pointer;
                  margin-left: 4px;
                "
                (click)="removeReferenceDocument(selectedRequirement, dri)"
                >close</mat-icon
              >
            </span>
          </div>
          <input
            #refFileInput
            type="file"
            multiple
            hidden
            (change)="onReferenceFileSelected($event, selectedRequirement)"
          />
        </div>

        <!-- Checklist Items -->
        <div class="mt-2">
          <label style="font-size: 12px; color: #666">Checklist Items</label>

          <div
            *ngFor="
              let item of selectedRequirement.checklist_items;
              let ii = index
            "
            class="checklist-item-card mt-2"
            style="
              border: 1px solid #e0e0e0;
              border-radius: 8px;
              background: #fafafa;
              overflow: hidden;
            "
          >
            <div
              class="d-flex align-items-center"
              style="gap: 4px; padding: 6px 8px"
            >
              <mat-icon
                style="
                  cursor: pointer;
                  font-size: 18px;
                  width: 18px;
                  height: 18px;
                "
                (click)="toggleChecklistItem(item)"
              >
                {{ item.expanded ? "expand_more" : "chevron_right" }}
              </mat-icon>
              <input
                class="tree-input"
                style="font-size: 13px"
                [(ngModel)]="item.name"
                name="checklistItem{{ ii }}"
                placeholder="Checklist item description"
              />
              <span
                class="badge bg-light text-dark"
                style="font-size: 10px"
                *ngIf="item.required_documents.length"
              >
                {{ item.required_documents.length }} doc{{
                  item.required_documents.length === 1 ? "" : "s"
                }}
              </span>
              <button
                mat-icon-button
                color="warn"
                matTooltip="Remove checklist item"
                style="width: 26px; height: 26px; line-height: 26px"
                (click)="removeChecklistItem(selectedRequirement, ii)"
              >
                <mat-icon style="font-size: 16px; width: 16px; height: 16px"
                  >delete</mat-icon
                >
              </button>
            </div>

            <div *ngIf="item.expanded" style="padding: 0 8px 10px 30px">
              <label style="font-size: 11px; color: #777"
                >Required Documents</label
              >
              <div class="d-flex flex-wrap align-items-center gap-1 mt-1 overflow-auto">
                <span
                  *ngFor="let doc of item.required_documents; let dci = index"
                  class="badge bg-secondary d-flex align-items-center"
                  style="padding: 6px 8px; font-size: 12px"
                >
                  {{ doc }}
                  <mat-icon
                    style="
                      font-size: 14px;
                      width: 14px;
                      height: 14px;
                      cursor: pointer;
                      margin-left: 4px;
                    "
                    (click)="removeChecklistDocument(item, dci)"
                    >close</mat-icon
                  >
                </span>
              </div>
              <div class="d-flex align-items-center mt-2" style="gap: 6px">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  style="max-width: 260px"
                  placeholder="Add a required document"
                  [(ngModel)]="item._docInput"
                  name="checklistDocInput{{ ii }}"
                  (keydown.enter)="
                    addChecklistDocument(item); $event.preventDefault()
                  "
                />
                <button
                  mat-icon-button
                  color="primary"
                  (click)="addChecklistDocument(item)"
                >
                  <mat-icon style="font-size: 18px">add</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <button
            mat-stroked-button
            color="primary"
            class="ms-2"
            style="font-size: 12px; padding: 0 10px; line-height: 30px"
            (click)="addChecklistItem(selectedRequirement)"
          >
            <mat-icon style="font-size: 16px; vertical-align: middle"
              >add</mat-icon
            >
            Add Checklist Item
          </button>
        </div>

        <!-- Responses -->
        <div class="mt-3">
          <label style="font-size: 12px; color: #666">Responses</label>
          <div
            *ngFor="
              let choice of selectedRequirement.response_choices;
              let ci = index
            "
            class="d-flex align-items-start mt-2"
            style="gap: 6px"
          >
            <mat-form-field appearance="outline" style="width: 180px">
              <mat-label> Response <span class="required">*</span> </mat-label>
              <input
                matInput
                [(ngModel)]="choice.response"
                name="responseDetail{{ ci }}"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" style="flex: 1">
              <mat-label>Response Description</mat-label>
              <input
                matInput
                [(ngModel)]="choice.response_description"
                name="responseDescDetail{{ ci }}"
              />
            </mat-form-field>
            <button
              mat-icon-button
              color="warn"
              matTooltip="Remove response"
              style="margin-top: 6px"
              [disabled]="selectedRequirement.response_choices.length === 1"
              (click)="removeResponseChoice(selectedRequirement, ci)"
            >
              <mat-icon style="font-size: 18px">delete</mat-icon>
            </button>
          </div>
          <button
            mat-stroked-button
            color="primary"
            style="font-size: 12px; padding: 0 10px; line-height: 30px"
            (click)="addResponseChoice(selectedRequirement)"
          >
            <mat-icon style="font-size: 16px; vertical-align: middle"
              >add</mat-icon
            >
            Add Response
          </button>
        </div>
      </ng-container>

      <ng-template #noSelection>
        <div
          class="d-flex flex-column align-items-center justify-content-center text-muted"
          style="height: 100%"
        >
          <mat-icon
            style="font-size: 40px; width: 40px; height: 40px; opacity: 0.4"
            >rule</mat-icon
          >
          <p class="mt-2">
            Select a requirement on the left, or add a new one, to edit it here.
          </p>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="d-flex justify-content-between mt-3">
    <button *ngIf="isCreateMode" mat-stroked-button (click)="goBack()">
      Back
    </button>
    <div class="d-flex gap-2 ms-auto">
      <button mat-button mat-dialog-close color="primary">Close</button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="saving || !isValid()"
        (click)="save()"
      >
        Save
      </button>
    </div>
  </div>
</div>
